import PageWithTitle from "@/PageWithTitle";

// The documentation terms of use, hosted at /docs-terms. Visitors accept these
// on the docs login page (DocsLoginPage) before being signed into the docs;
// this page is the canonical, linkable full text.
function DocsTermsPage() {
  return (
    <PageWithTitle title="Documentation Terms of Use">
      <div className="bg-surface-sunken flex h-screen items-start justify-center overflow-y-auto px-4 py-12">
        <div className="border-borderSubtle bg-surface-default w-[720px] max-w-full rounded-xl border p-8 shadow-sm sm:p-10">
          <div className="flex items-center gap-3">
            <div className="flex size-10 items-center justify-center rounded-lg bg-blue-500 text-sm font-bold text-white">
              FP
            </div>
            <div>
              <div className="text-textDefault font-semibold">
                Freshpaint Docs
              </div>
              <div className="text-textSubtle text-sm">
                Documentation Terms of Use
              </div>
            </div>
          </div>

          <div className="text-textDefault mt-8 space-y-6 text-sm leading-6">
            <section>
              <h2 className="text-textDefault text-base font-semibold">
                Proprietary Rights &amp; Use Restrictions
              </h2>
              <blockquote className="border-borderSubtle text-textSubtle mt-3 space-y-3 border-l-2 pl-4">
                <p>
                  By accessing Freshpaint Documentation, you acknowledge that
                  all content, architectures, and technical workflows are the
                  exclusive intellectual property of Freshpaint, Inc.
                </p>
                <p>
                  <span className="text-textDefault font-medium">
                    Prohibited Use:
                  </span>{" "}
                  You expressly agree not to use, copy, or distribute this
                  documentation, in whole or in part, to:
                </p>
                <ol className="list-decimal space-y-1 pl-6">
                  <li>
                    Develop, benchmark, or market a competitive product or
                    service.
                  </li>
                  <li>
                    Train machine learning models or LLMs intended for
                    commercial use.
                  </li>
                  <li>
                    Disclose technical specifications to third parties whose
                    primary business competes with Freshpaint&rsquo;s
                    privacy-first data platform.
                  </li>
                </ol>
                <p>
                  <span className="text-textDefault font-medium">
                    Remedies:
                  </span>{" "}
                  Any breach of these terms constitutes a material violation of
                  our service agreement and may result in immediate revocation
                  of access and legal action for trade secret misappropriation.
                </p>
              </blockquote>
            </section>

            <section>
              <h2 className="text-textDefault text-base font-semibold">
                Documentation Access Notice
              </h2>
              <p className="mt-3">
                To access Freshpaint&rsquo;s technical product documentation,
                you must create or sign in to a Freshpaint account. Access is
                available only to current or prospective business customers,
                partners, and other users authorized by Freshpaint. By creating
                an account, signing in, or otherwise accessing the
                documentation, you acknowledge that you have reviewed and agree
                that your access to and use of the documentation is governed by
                the terms below and any applicable agreement between you and
                Freshpaint.
              </p>
            </section>

            <section>
              <h2 className="text-textDefault text-base font-semibold">
                Documentation Terms of Use
              </h2>
              <div className="mt-3 space-y-3">
                <p>
                  &ldquo;Documentation&rdquo; means the end user technical
                  documentation for the Service, together with any related
                  service documentation, implementation materials, technical
                  descriptions, specifications, examples, or descriptions of
                  product features that Freshpaint makes available to Customer
                  electronically through this website, in each case as
                  Freshpaint may modify from time to time.
                </p>
                <p>
                  Freshpaint provides access to the Documentation solely for use
                  by current or prospective business customers, partners, and
                  other authorized users for purposes of evaluating,
                  implementing, supporting, or using the Service.
                </p>
                <p>
                  The Documentation, including any non-public materials,
                  examples, specifications, technical information, and other
                  content made available through this website, is proprietary to
                  Freshpaint and may constitute Freshpaint confidential
                  information.
                </p>
                <p>
                  You may use the Documentation only for your internal business
                  purposes in connection with your evaluation, implementation,
                  support, or authorized use of the Service. You may not copy,
                  reproduce, distribute, modify, publish, display, disclose, or
                  otherwise make the Documentation available to any third party,
                  except as expressly authorized in writing by Freshpaint.
                </p>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your account credentials and for all activity occurring under
                  your account in connection with access to the Documentation.
                  Freshpaint may approve, deny, suspend, restrict, or revoke
                  access to the Documentation at any time in its discretion.
                </p>
                <p>
                  The Documentation is provided by Freshpaint on an &ldquo;as
                  is&rdquo; basis and may be updated, changed, or removed at any
                  time without notice. Freshpaint does not commit to maintain
                  any particular Documentation content or to provide advance
                  notice of revisions.
                </p>
                <p>
                  Access to and use of the Documentation is subject to these
                  Documentation Terms of Use and, where applicable, your master
                  services agreement, terms of service, mutual nondisclosure
                  agreement, or other written agreement with Freshpaint. In the
                  event of a conflict between these Documentation Terms of Use
                  and an applicable written agreement with Freshpaint, the
                  written agreement will control to the extent of the conflict.
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </PageWithTitle>
  );
}

export default DocsTermsPage;
